import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FieldValueInterface } from '@vendasta/crm';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { BlankValueComponent, CustomCellComponent } from '@vendasta/galaxy/table';
import { BehaviorSubject, catchError, distinctUntilChanged, map, Observable, of, switchMap } from 'rxjs';
import { CrmInjectionToken, SimplifiedUser } from '@galaxy/crm/static';

@Component({
  selector: 'crm-user-column-cell',
  templateUrl: 'user-column-cell.component.html',
  styleUrls: ['./user-column-cell.component.scss'],
  imports: [CommonModule, BlankValueComponent, GalaxyAvatarModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CrmUserColumnCellComponent extends CustomCellComponent {
  private readonly userService = inject(CrmInjectionToken).services?.userService;

  set value(newValues: FieldValueInterface[] | null) {
    this.value$$.next(newValues);
  }

  private readonly value$$ = new BehaviorSubject<FieldValueInterface[] | null>(null);
  protected readonly AVATAR_WIDTH = 24;
  protected readonly userInfo$ = this.setupUserInfo();

  setupUserInfo(): Observable<SimplifiedUser | null> {
    return this.value$$.pipe(
      map((value) => value?.[0]?.stringValue),
      distinctUntilChanged(),
      switchMap((value) => this.getUserInfo(value)),
    );
  }

  getUserInfo(userId?: string): Observable<SimplifiedUser | null> {
    const result$ = userId
      ? this.userService?.getMultiUsers([userId]).pipe(
          map((users) => users?.[0]),
          catchError(() => of(null)),
        )
      : undefined;
    return result$ ?? of(null);
  }
}
